import React, { useState } from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'
import Card from '../ui/Card'
import Button from '../ui/Button'
import RewardAnalytics from './RewardAnalytics'
import RewardHistory from './RewardHistory'

const { FiBarChart3, FiClock, FiTrendingUp, FiList } = FiIcons

const RewardTracker = () => {
  const [activeTab, setActiveTab] = useState('analytics') // analytics, history

  const tabs = [
    {
      id: 'analytics',
      label: 'Analytics',
      icon: FiBarChart3,
      description: 'View insights and trends'
    },
    {
      id: 'history',
      label: 'History',
      icon: FiClock,
      description: 'Complete redemption log'
    }
  ]

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <Card className="p-1">
        <div className="flex rounded-lg bg-gray-100 dark:bg-gray-800">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-all duration-200 ${
                activeTab === tab.id
                  ? 'bg-white dark:bg-gray-700 text-primary-600 dark:text-primary-400 shadow-sm'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              <SafeIcon icon={tab.icon} className="text-lg" />
              <div className="text-left">
                <div>{tab.label}</div>
                <div className="text-xs opacity-75">{tab.description}</div>
              </div>
            </button>
          ))}
        </div>
      </Card>

      {/* Tab Content */}
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {activeTab === 'analytics' && <RewardAnalytics />}
        {activeTab === 'history' && <RewardHistory />}
      </motion.div>
    </div>
  )
}

export default RewardTracker